<template>
  <div class="story-block" v-loading="load">
      <div class="story-title">Активность</div>
      
        <staggered-fade :duration="250" tag="div" class="story-list">
            <div class="story-one" v-for="(item, index) in items_sliced" :key="index" :data-index="index" :data-type="item.type">
          <div class="story-icon" v-html="$root.icons[item.icon]"></div>
          <div class="story-info">
            <div class="story-info__title">{{ item.title }}</div>
            <div class="story-info__date">{{ item.date }}</div>
          </div>
        </div>
        </staggered-fade>
        
        <a class="button-activity button btn-border" v-if="items.length > 3" @click="openLog">Посмотреть всю активность</a>
      </div>

  </div>
</template>

<script>
import axios from "axios";
import StaggeredFade from "./layouts/StaggeredFade.vue";

export default {
  name: "Search",
  components: {
    "staggered-fade": StaggeredFade,
  },
  data: function () {
    return {
      load: true,
      items: [],
    };
  },
  computed: {
    uid() {
      return this.$root.app.trigger;
    },
    items_sliced() {
      if (this.items.length == 0) return [];
      return this.items.slice(0, 3);
    },
  },
  watch: {
    uid: function () {
      this.getData();
    },
  },
  methods: {
    openLog() {
      this.$root.app.log_items = this.items;
      this.$root.app.full_log = true;
    },
    getData() {
      this.load = true;
      axios
        .post(this.$root.app.way + "/ajax/", {
          action: "get-data-story",
          hash: this.$route.params.bid,
        })
        .then((response) => {
          this.load = false;
          this.items = response.data ? response.data.data : [];
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.story-block {
  display: flex;
  width: 100%;
  min-height: 120px;
  margin-top: 32px;
  /* background-color: #fff; */
  border-radius: 4px;
  /* box-shadow: 6px 0 18px rgba(0, 0, 0, 0.06); */
  z-index: 10;
  transition: 0.25s;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  overflow: hidden;
}

.story-block.el-loading-parent--relative .el-loading-mask {
  background-color: rgba(3, 104, 250, 0.15);
}

.story-title {
  margin-bottom: 16px;
  font-weight: 500;
  color: #455c79;
  opacity: 0.7;
  font-size: 11px;
  text-transform: uppercase;
}
.story-list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
}

.story-one {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  position: relative;
}

.story-icon {
  height: 20px;
  width: 20px;
  border-radius: 3px;
  background-color: whitesmoke;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
  flex-shrink: 0;
}

.story-icon svg {
  height: 13px;
}

.story-info {
  flex-grow: 1;
  padding-left: 18px;
}

.story-info__title {
  min-height: 20px;
  line-height: 20px;
  font-size: 13px;
  font-weight: 500;
}

.story-info__date {
  font-size: 12px;
  margin-top: 3px;
  color: #0368fa;
}

.story-one[data-type="send"] .story-icon {
  background-color: rgba(3, 104, 250, 0.15);
}

.story-one[data-type="send"] .story-icon svg {
  stroke: #0368fa;
}

.story-one[data-type="download"] .story-icon {
  background-color: rgba(16, 183, 89, 0.15);
}

.story-one[data-type="download"] .story-icon svg {
  stroke: #10b759;
}

.story-one[data-type="share_open"] .story-icon {
  background-color: rgba(253, 126, 20, 0.15);
}

.story-one[data-type="share_open"] .story-icon svg {
  stroke: #fd7e14;
}

.story-one + .story-one {
  margin-top: 24px;
}

.story-one + .story-one::after {
  content: "";
  height: 32px;
  width: 1px;
  background-color: #e5e5e5;
  position: absolute;
  left: 9px;
  bottom: 100%;
  transform: translate(0, -6px);
}
.button-activity {
  margin-top: 24px;
}
</style>
